module.exports = __webpack_public_path__ + "assets/media/s7.4f504c31.mp3";